import { apiFetch } from "./apiClient";

const BASE = "/api/services/service-plans/device-plans";

export async function getDeviceServicePlans(filters = {}) {
  const params = new URLSearchParams();

  if (filters.deviceId != null)
    params.set("device_id", String(filters.deviceId));
  if (filters.roomId != null) params.set("room_id", String(filters.roomId));
  if (filters.servicePlanTemplateId != null) {
    params.set(
      "service_plan_template_id",
      String(filters.servicePlanTemplateId),
    );
  }
  if (filters.routeTemplateId != null) {
    params.set("route_template_id", String(filters.routeTemplateId));
  }
  if (filters.assignedUserId != null) {
    params.set("assigned_user_id", String(filters.assignedUserId));
  }
  if (filters.active != null) params.set("active", String(filters.active));
  if (filters.activeOnDate)
    params.set("active_on_date", String(filters.activeOnDate));

  const query = params.toString() ? `?${params.toString()}` : "";
  const res = await apiFetch(`${BASE}${query}`);
  if (!res.ok) {
    throw new Error("Failed to fetch device service plans");
  }
  return res.json();
}

export async function createDeviceServicePlan(payload) {
  const res = await apiFetch(BASE, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to create device service plan");
  }

  return res.json();
}

export async function getDeviceServicePlanById(planId) {
  const res = await apiFetch(`${BASE}/${planId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch device service plan");
  }
  return res.json();
}

export async function updateDeviceServicePlan(planId, payload) {
  const res = await apiFetch(`${BASE}/${planId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update device service plan");
  }

  return res.json();
}

export async function replaceDevicePlanTaskOverrides(planId, overrides) {
  const res = await apiFetch(`${BASE}/${planId}/task-overrides`, {
    method: "PUT",
    body: JSON.stringify({ overrides }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update device plan task overrides");
  }

  return res.json();
}

export async function syncDevicePlanFutureJobs(planId, payload = {}) {
  const res = await apiFetch(`${BASE}/${planId}/sync-future-jobs`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to sync future jobs for device plan");
  }

  return res.json();
}
